import { render, staticRenderFns } from "./RegistrationCompleted.vue?vue&type=template&id=a418a7b8&scoped=true&"
import script from "./RegistrationCompleted.vue?vue&type=script&lang=js&"
export * from "./RegistrationCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a418a7b8",
  null
  
)

export default component.exports